import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { baseUrl, privateConfig } from "../../../routes/config";
import SideBar from "../../UI/SideBar/SideBar";
import TopBar from "../../UI/TopBar/TopBar";
import "./index.css";

const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="xrg-dashboard-shell">
      <SideBar
        menuData={privateConfig}
        panelName="Superadmin"
        baseUrl={baseUrl}
        collapsed={collapsed}
      />
      <div className={`xrg-content ${collapsed ? "xrg-content--collapsed" : ""}`}>
        <TopBar
          menuData={privateConfig}
          onToggleSidebar={() => setCollapsed((c) => !c)}
        />
        <div className="xrg-outlet-main">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
